import {useState, useEffect} from 'react';
import {
    Modal,
    Box,
    Button,
    Typography,
    FormControlLabel,
    Checkbox,
    Stack,
    Divider,
} from '@mui/material';

const ContactsFilterCategories = (
    {
        open,
        categories,
        handleClose,
        handleFilter,
        fetchCategoriesData,
        currentPage,
        setCurrentPage,
        itemsPerPage = 5, // ⭐ Nuevo prop con valor por defecto
        // initialSelectedCategories = [], // ⭐ Nueva prop opcional
    }
) => {
    const [localSelectedCategories, setLocalSelectedCategories] = useState([]);

    // Resetear selección al cerrar el modal
    useEffect(() => {
        if (!open) {
            setLocalSelectedCategories([]);
        }
    }, [open]);

    // Maneja el cambio de estado del checkbox comparando por ID
    const handleCheckboxChange = (category) => {
        setLocalSelectedCategories((prev) => {
            const isSelected = prev.some(c => c.id === category.id);
            if (isSelected) {
                return prev.filter((c) => c.id !== category.id);
            } else {
                return [...prev, category];
            }
        });
    };

    // Verificar si una categoría está seleccionada
    const isCategorySelected = (category) => {
        return localSelectedCategories.some(c => c.id === category.id);
    };

    const handleNextPage = () => {
        const nextPage = currentPage + 1;
        setCurrentPage(nextPage);
        fetchCategoriesData(nextPage);
    };

    const handlePreviousPage = () => {
        if (currentPage > 0) {
            const prevPage = currentPage - 1;
            setCurrentPage(prevPage);
            fetchCategoriesData(prevPage);
        }
    };

    const handleCloseAndFilter = () => {
        console.log('Categorías seleccionadas:', localSelectedCategories);
        handleFilter(localSelectedCategories);
        handleClose();
    };

    const handleCloseWithoutFilter = () => {
        setLocalSelectedCategories([]);
        handleClose();
    };

    // Verificación: Asegurar que categories tiene la estructura correcta
    const categoryItems = categories?.items || [];
    const categoryCount = categories?.count || 0;

    // ⭐ Calcular el total de páginas basado en offset
    const totalPages = Math.max(1, Math.ceil(categoryCount / itemsPerPage));

    return (
        <Modal open={open} onClose={handleCloseWithoutFilter}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 450,
                    maxHeight: '80vh',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 3,
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Typography variant="h6" gutterBottom>
                    Seleccionar Categorías
                </Typography>

                {localSelectedCategories.length > 0 && (
                    <Typography variant="caption" color="primary" sx={{mb: 1}}>
                        {localSelectedCategories.length} categoría(s) seleccionada(s)
                    </Typography>
                )}

                <Divider sx={{my: 1}}/>

                {/* Lista con scroll */}
                <Box sx={{
                    flex: 1,
                    overflowY: 'auto',
                    maxHeight: '400px',
                    mb: 2
                }}>
                    {categoryItems.length > 0 ? (
                        categoryItems.map((category) => (
                            <Box key={category.id}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isCategorySelected(category)}
                                            onChange={() => handleCheckboxChange(category)}
                                            name={category.name}
                                        />
                                    }
                                    label={category.name}
                                />
                            </Box>
                        ))
                    ) : (
                        <Typography variant="body2" color="text.secondary" align="center" sx={{py: 2}}>
                            No hay categorías disponibles
                        </Typography>
                    )}
                </Box>

                <Divider sx={{my: 1}}/>

                {/* Paginación */}
                <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{mb: 2}}>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handlePreviousPage}
                        disabled={currentPage === 0}
                    >
                        Anterior
                    </Button>
                    <Typography variant="body2">
                        Página {currentPage + 1} de {totalPages}
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleNextPage}
                        disabled={currentPage + 1 >= totalPages}
                    >
                        Siguiente
                    </Button>
                </Stack>

                {/* Botones de acción */}
                <Stack direction="row" spacing={2}>
                    <Button
                        variant="outlined"
                        onClick={handleCloseWithoutFilter}
                        sx={{flex: 1}}
                    >
                        Cancelar
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleCloseAndFilter}
                        disabled={localSelectedCategories.length === 0}
                        sx={{flex: 1}}
                    >
                        Aplicar Filtro ({localSelectedCategories.length})
                    </Button>
                </Stack>
            </Box>
        </Modal>
    );
};

export default ContactsFilterCategories;